
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/center/isha-research-center/projects/[project]",
      function () {
        return require("private-next-pages/[region]/center/isha-research-center/projects/[project]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/center/isha-research-center/projects/[project]"])
      });
    }
  